import { FC } from 'react';
import VendorForm from '../components/vendors/VendorForm';
import { WrapInLayout } from '../layouts';

const VendorNewPage: FC = () => {
  return (
    <WrapInLayout title="New Vendor" layout="portal">
      <VendorForm />
    </WrapInLayout>
  );
};

export default VendorNewPage;
